import PropTypes from "prop-types";
import { Trash2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Controlled shadcn confirmation dialog for destructive actions. The caller
 * owns the open state and provides an async `onConfirm`; closing after a
 * successful action is the caller's responsibility.
 */
const ConfirmDeleteDialog = ({
  open,
  onOpenChange,
  title = "Delete?",
  description,
  confirmText = "Delete",
  cancelVariant = "outline",
  onConfirm,
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent size="sm">
      <AlertDialogHeader>
        <AlertDialogMedia className="tw:bg-destructive/10 tw:text-destructive tw:dark:bg-destructive/20 tw:dark:text-destructive">
          <Trash2 />
        </AlertDialogMedia>
        <AlertDialogTitle as="span">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel variant={cancelVariant}>Cancel</AlertDialogCancel>
        <AlertDialogAction variant="destructive" onClick={onConfirm}>
          {confirmText}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

ConfirmDeleteDialog.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.node,
  confirmText: PropTypes.string,
  cancelVariant: PropTypes.string,
  onConfirm: PropTypes.func,
};

export default ConfirmDeleteDialog;
